import React from "react";

const NeutralStaffLine = ({color = "currentColor"}) => (
    <svg width="25" height="25" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25">
        <g
            stroke={color}
            fill="none"
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path
                className="prefix__cls-1"
                d="M12.5 2.06a5.68 5.68 0 00-5.67 5.67v3c0 3.47 3.9 6.71 5.67 6.71s5.67-3.24 5.67-6.71v-3a5.68 5.68 0 00-5.67-5.67z"
            />
            <path
                className="prefix__cls-1"
                d="M21.89 17.47l-4.09-1.14-1-.27a10.61 10.61 0 01-.85.8l1.15.32-1.34 6.72H9.32l-1.41-6.71 1.18-.32a10.72 10.72 0 01-.86-.8l-1 .28-4.12 1.12a4.66 4.66 0 00-3 4.34v2.59a.5.5 0 00.5.5H24.4a.5.5 0 00.5-.5v-2.59a4.65 4.65 0 00-3.01-4.34z"
            />
        </g>
    </svg>
);

export default NeutralStaffLine;
